import { defineStore } from 'pinia'
import httpClient from '@/api/httpClient'
import { useMessagesStore } from '@/stores/messages'

export const useAdminConfigurationStore = defineStore('admin_configuration', {
  state: () => ({
    settings: [],
    maxRetentionDays: 365,
    storiesOptionalColumns: [],
    storiesDefaultVisibleColumns: []
  }),

  actions: {
    async fetch() {
      return httpClient.get('/api/internal/admin_configuration')
        .then(({ data }) => {
          this.settings = data.admin_settings
          this.maxRetentionDays = data.max_retention_days
          this.storiesOptionalColumns = data.stories_optional_columns
          this.storiesDefaultVisibleColumns = data.stories_default_visible_columns
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
        })
    },

    async save() {
      return httpClient.patch('/api/internal/admin_configuration', {
        admin_settings: this.settings.map(s => ({ key: s.key, value: s.value }))
      })
        .then(() => {
          useMessagesStore().addNotice('Configuration saved')
        })
        .catch(err => {
          console.error(err)
          useMessagesStore().addError(err)
          throw err
        })
    }
  }
})
